import { useMemo } from 'react';

import { SamplingProductQuote } from 'src/shared/types/sampling';
import getDiscountLabel from 'src/shared/utils/getDiscountLabel';

import { NEXT_SAMPLE_50_DISCOUNT } from 'src/shared/components/DiscountBanner';
import { Typography } from 'src/shared/components/ui';

interface SampleTotalCostWithDiscountProps {
  product_quote: SamplingProductQuote;
}

const SampleTotalCostWithDiscount = ({
  product_quote
}: SampleTotalCostWithDiscountProps) => {
  const discount = useMemo(() => {
    const discount = product_quote?.discounts?.find(
      (discount) => discount?.id === NEXT_SAMPLE_50_DISCOUNT
    );

    return discount;
  }, [product_quote?.discounts]);

  if (!product_quote) return null;

  if (discount) {
    return (
      <div className="flex items-center gap-2">
        <Typography variant="h4" weight="bold" className="line-through">
          ${discount?.original_price}
        </Typography>
        <Typography variant="h4" weight="bold" className="text-primary">
          ${discount?.discounted_price}
        </Typography>
        <div className="bg-tertiary px-2 rounded-md w-fit">
          <Typography variant="body-2" weight="medium" className="text-primary">
            {getDiscountLabel(discount)}
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <Typography variant="h4" weight="bold">
      ${product_quote?.sample_total_cost_marked_up}
    </Typography>
  );
};

export default SampleTotalCostWithDiscount;
